// extracted by mini-css-extract-plugin
export default {"header":"UI","container":"VI","accordeonitem":"WI","itemsticky":"XI","itemopen":"YI","open":"ZI","productname":"aJ","productinfo":"bJ","flavorstext":"cJ","invalidlimit":"eJ","limit":"fJ","scrollUpAccordion":"gJ","wrapper":"hJ"};
    if(module.hot) {
      // 1714654894040
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  